<template>
  <v-row no-gutters class="px-3 my-2 text-caption">
    <v-col
      cols="8"
      class="grey--text text-truncate"
    >
      <v-icon left small v-text="icons.user" />{{ order.tenantUserName }}
    </v-col>
    <v-col
      v-if="amountToBePaid > 0"
      cols="4"
      class="font-weight-bold text-truncate text-right"
      @click="toggle()"
    >
      <v-icon left small v-text="icons.coins" />{{ amountToBePaid | currency }}
    </v-col>
    <v-col
      cols="8"
      class="grey--text text-truncate"
      @click="timeTooltip = ! timeTooltip"
    >
      <v-icon left small v-text="icons.clock" />{{ time }}
    </v-col>
    <v-col
      v-if="order.alreadyPaid > 0"
      cols="4"
      class="text-truncate text-right"
      @click="toggle()"
    >
      {{ order.alreadyPaid | currency }}
    </v-col>
  </v-row>
</template>

<script>
  import Currenciable from '@/Mixins/Currenciable'
  import UsesIcons from '@/Mixins/UsesIcons'

  export default {
    mixins: [
      Currenciable,
      UsesIcons,
    ],

    data: () => ({
      timeTooltip: false,
      computedTime: '',
    }),

    computed: {
      order () {
        return this.$store.state.orders.current
      },
      amountToBePaid () {
        return Math.max(this.order.total - this.order.alreadyPaid, 0)
      },
      time () {
        return this.timeTooltip
          ? this.order.openedMoment.format('L LT')
          : this.computedTime
      },
    },

    created () {
      this.computeTime()
      setInterval(() => this.computeTime(), 30000)
    },

    watch: {
      order () {
        this.computeTime()
      },
    },

    methods: {
      computeTime () {
        this.computedTime = this.order.openedMoment.fromNow()
      },
      toggle () {
        this.$store.commit('orders/toggleShowPaid')
      },
    },
  }
</script>
